import React, { Component } from "react";
import emailjs from 'emailjs-com';
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import PaymentModal from "../elements/callaction/PaymentModal";


class ServiceDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false,
          showModal: false,
          selectedService: "",
          name: "",
          email: "",
          phone: "",
          paymentLink: ""
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    handlePaymentClick = (service, link) => {
        // this.setState({ showModal: true, selectedService: service, paymentLink: link });

        // No need for the modal since mainstack collects user data
        // Redirect to payment page
        window.open(link, "_blank");
    };
    
    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    handleSubmit = (event) => {
        event.preventDefault();
        
        const { name, email, phone, paymentLink } = this.state;
        
        if (!name || !email || !phone) {
            alert("Please fill in all fields before proceeding.");
            return;
        }

        const templateParams = {
            from_name: name,
            from_email: email,
            phone_number: phone,
            service_name: "Business Transformation Catalyst",
            payment_link: paymentLink,
        };
          
        emailjs.send('30n55zb', 'template_07g0ktb', templateParams, 'mznTwnc4RFD-CG9XN')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                // Redirect to payment page
                window.open(paymentLink, "_blank");
                    
                // Close the modal
                this.setState({ showModal: false });
            })
            .catch((err) => {
                console.error('FAILED...', err);
                alert('FAILED...', err);
            });
    };
    render(){
        return(
            <React.Fragment>
                
                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Service Details' />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190"  data-black-overlay="10">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">Business Transformation Catalyst</h2>
                                    <p>Strategic Vision and Execution</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/service/transformation.jpg" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <p>In an age of unprecedented disruption, businesses must constantly reinvent to thrive. This high-impact coaching service, "Business Transformation Catalyst," empowers you to become a driving force for organisational change, guiding strategic vision and executing impactful transformations.</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-8 col-12 order-2 order-lg-1">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <h5 className="title mt-3">Why I Created This Mentoring Service</h5>
                                                    <p>Witnessing businesses struggle to adapt and innovate, I realised the urgent need for professionals equipped to lead transformative change. This mentorship is designed to cultivate those catalysts, empowering them to drive strategic vision and deliver tangible results.</p>

                                                    <h5 className="title mt-3">Mentorship Plan</h5>
                                                    <ul className="liststyle">
                                                        <li>Phase 1: Cultivating a Transformational Mindset: Developing strategic foresight and embracing disruptive innovation.</li>
                                                        <li>Phase 2: Strategic Planning & Vision Development: Crafting compelling visions and developing actionable strategic plans.</li>
                                                        <li>Phase 3: Building Cross-Functional Collaboration: Fostering alignment and synergy across organisational silos.</li>
                                                        <li>Phase 4: Driving Execution & Measuring Impact: Implementing change initiatives and quantifying results.</li>
                                                        <li>Phase 5: Leading Sustainable Transformation & Innovation: Creating a culture of continuous improvement and lasting impact.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">In this mentorship, you will learn how to:</h5>
                                                    <ul className="liststyle">
                                                        <li>Develop a transformational mindset for navigating disruption.</li>
                                                        <li>Craft compelling strategic visions and actionable plans.</li>
                                                        <li>Foster cross-functional collaboration and alignment.</li>
                                                        <li>Drive impactful execution and measure tangible results.</li>
                                                        <li>Lead sustainable transformation and innovation initiatives.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">What will you gain?</h5>
                                                    <p>By the end of this mentorship, you will gain:</p>

                                                    <h6 className="mt-3">A personalised business transformation framework</h6>
                                                    <ul className="liststyle">
                                                        <li>Advanced strategic planning and vision development skills.</li>
                                                        <li>The ability to build and lead collaborative cross-functional teams.</li>
                                                        <li>Enhanced execution and impact measurement capabilities.</li>
                                                        <li>The confidence to drive large-scale transformation initiatives.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">Who is this mentorship program for?</h5>
                                                    <ul className="liststyle">
                                                        <li>Executives and Senior Leaders: Those responsible for driving strategic change and organisational transformation.</li>
                                                        <li>Business Owners and Entrepreneurs: Individuals looking to reinvent their businesses for growth and competitiveness.</li>
                                                        <li>Innovation Leaders and Managers: Professionals tasked with fostering innovation and driving strategic initiatives.</li>
                                                        <li>Change Management Professionals: Individuals seeking to enhance their ability to lead large-scale transformation projects.</li>
                                                        <li>Strategic Planners and Consultants: Professionals involved in developing and implementing business strategies.</li>
                                                        <li>Leaders of Digital Transformation Initiatives: Individuals driving the adoption of new technologies and business models.</li>
                                                        <li>Professionals aiming to become catalysts for organisational change: Those seeking to make a significant impact on their organisations.</li>
                                                        <li>Individuals seeking to develop a transformational mindset: Those looking to lead in periods of disruption.</li>
                                                        <li>Professionals wanting to improve their strategic vision and execution skills: Those needing to implement large-scale changes.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">How is the mentorship structured?</h5>
                                                    <p>This intensive 6-month Program features personalised one-on-one sessions, strategic workshops, and ongoing support. You will also gain access to exclusive resources and a network of business transformation leaders.</p>

                                                    <h5 className="title mt-3">FAQs:</h5>
                                                    <ol className="liststyle">
                                                        <li>Is this mentorship suitable for professionals in all industries?</li>
                                                        <p style={{ listStyle: 'none' }}>Yes, the principles of business transformation apply to all sectors facing disruption.</p>

                                                        <li>Will this mentorship help me develop a strategic vision?</li>
                                                        <p style={{ listStyle: 'none' }}>Absolutely. We dedicate a significant portion of the Program to crafting compelling visions and strategic plans.</p>

                                                        <li>How much time commitment is required for this mentorship?</li>
                                                        <p style={{ listStyle: 'none' }}>Expect to dedicate approximately 5  hours per week to mentorship sessions and strategic application.</p>
                                                    </ol>

                                                    <div className="flex-wrap mt-5 align-items-center">
                                                        <h5 className="title mb-0 mr-3">Enrol Now £699</h5>

                                                        <div
                                                            className="payment-buttons btn btn-outline-danger d-inline-flex align-items-center px-3 py-2"
                                                            onClick={() => this.handlePaymentClick("Business Transformation Catalyst",
                                                                "https://mainstack.store/coachdoi/kPqQswhMRMyo")}
                                                            style={{ cursor: "pointer", borderRadius: "4px" }}
                                                        >
                                                            <span style={{ fontWeight: "500" }}>Pay with </span>
                                                            <img
                                                                src="/assets/images/icons/mainstack.png"
                                                                alt="Mainstack"
                                                                className="btn-icon ml-2 img-fluid"
                                                                style={{ height: "20px", maxWidth: "100%" }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                <PaymentModal
                    show={this.state.showModal}
                    onClose={() => this.setState({ showModal: false })}
                    onSubmit={this.handleSubmit}
                    name={this.state.rnName}
                    email={this.state.rnEmail}
                    phone={this.state.rnPhone}
                    service={this.state.selectedService}
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                />
                
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo />

            </React.Fragment>
        )
    }
}
export default ServiceDetails;